export const medicalSpecialties = [
  // Medical Specialties
  { label: "Orthopedics and Physical Therapy", value: "Orthopedics and Physical Therapy" },
  { label: "Cardiology", value: "Cardiology" },
  { label: "Oral Surgery and Dentistry", value: "Oral Surgery and Dentistry" },
  { label: "Pediatrics", value: "Pediatrics" },
  { label: "Optometry & Ophthalmology", value: "Optometry & Ophthalmology" },
  { label: "Family Medicine & Primary Care", value: "Family Medicine & Primary Care" },
  { label: "Allergy & ENT", value: "Allergy & ENT" },
  { label: "Urology", value: "Urology" },
  { label: "Behavioral Health", value: "Behavioral Health" },
  { label: "Psychiatry (Advanced Behavioral Health, e.g., long-acting injectables)", value: "Psychiatry (Advanced Behavioral Health, e.g., long-acting injectables)" },
  { label: "Plastic Surgery", value: "Plastic Surgery" },
  { label: "Dermatology", value: "Dermatology" },
  { label: "Women's Health & Ob-Gyn", value: "Women's Health & Ob-Gyn" },
  { label: "Gastroenterology", value: "Gastroenterology" },
  { label: "Pain Management", value: "Pain Management" },
  { label: "Urgent Care", value: "Urgent Care" },
  { label: "Oncology / Hematology", value: "Oncology / Hematology" },
  { label: "Rheumatology", value: "Rheumatology" },
  { label: "Neurology", value: "Neurology" },
  { label: "Immunology / Autoimmune Diseases (e.g., Crohn's, Ulcerative Colitis, Psoriasis)", value: "Immunology / Autoimmune Diseases (e.g., Crohn's, Ulcerative Colitis, Psoriasis)" },
  { label: "Rare & Orphan Diseases", value: "Rare & Orphan Diseases" },
  { label: "Infusion Centers / Home Infusion (as a care delivery setting)", value: "Infusion Centers / Home Infusion (as a care delivery setting)" },
  { label: "Hospital Outpatient Departments / Specialty Clinics", value: "Hospital Outpatient Departments / Specialty Clinics" },
  { label: "Clinical Trials & Precision Medicine", value: "Clinical Trials & Precision Medicine" }
];

// Provider role types for affiliations
export const providerRoleTypes = [
  { label: "Attending Physician", value: "Attending Physician" },
  { label: "Chief of Staff", value: "Chief of Staff" },
  { label: "Department Head", value: "Department Head" },
  { label: "Medical Director", value: "Medical Director" },
  { label: "Associate Medical Director", value: "Associate Medical Director" },
  { label: "Consultant", value: "Consultant" },
  { label: "Staff Physician", value: "Staff Physician" },
  { label: "Hospitalist", value: "Hospitalist" },
  { label: "Emergency Physician", value: "Emergency Physician" },
  { label: "On-Call Physician", value: "On-Call Physician" },
  { label: "Covering Physician", value: "Covering Physician" },
  { label: "Primary Care Physician", value: "Primary Care Physician" },
  { label: "Specialist", value: "Specialist" },
  { label: "Surgeon", value: "Surgeon" },
  { label: "Anesthesiologist", value: "Anesthesiologist" },
  { label: "Radiologist", value: "Radiologist" },
  { label: "Pathologist", value: "Pathologist" },
  { label: "Resident Physician", value: "Resident Physician" },
  { label: "Fellow", value: "Fellow" },
  { label: "Intern", value: "Intern" },
  { label: "Locum Tenens", value: "Locum Tenens" },
  { label: "Telemedicine Physician", value: "Telemedicine Physician" },
  { label: "Medical Examiner", value: "Medical Examiner" },
  { label: "Coroner", value: "Coroner" },
  { label: "Medical Review Officer", value: "Medical Review Officer" },
  { label: "Independent Medical Examiner", value: "Independent Medical Examiner" },
  { label: "Expert Witness", value: "Expert Witness" },
  { label: "Medical Advisor", value: "Medical Advisor" },
  { label: "Clinical Researcher", value: "Clinical Researcher" },
  { label: "Principal Investigator", value: "Principal Investigator" },
  { label: "Medical Educator", value: "Medical Educator" },
  { label: "Professor", value: "Professor" },
  { label: "Associate Professor", value: "Associate Professor" },
  { label: "Assistant Professor", value: "Assistant Professor" },
  { label: "Clinical Instructor", value: "Clinical Instructor" },
  { label: "Volunteer Physician", value: "Volunteer Physician" }
];

// Certification and board status options
export const boardCertificationStatus = [
  { label: "Board Certified", value: "Board Certified" },
  { label: "Board Eligible", value: "Board Eligible" },
  { label: "Board Ineligible", value: "Board Ineligible" },
  { label: "Not Applicable", value: "Not Applicable" }
];

// License status options
export const licenseStatus = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Suspended", value: "Suspended" },
  { label: "Revoked", value: "Revoked" },
  { label: "Expired", value: "Expired" },
  { label: "Pending", value: "Pending" },
  { label: "Restricted", value: "Restricted" }
]; 